import { useNavigate } from 'react-router-dom';
import { AppDispatch, RootState } from '../store';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import AppMenu from '../components/app-menu';
import { loadAuthData } from '../store/slices/auth';
import { Grid, Typography, useTheme } from '@mui/material';
import BreadCrumbsBar from '../components/breadcrumbs-bar';

const WORDS_TO_CHANGE = {
    'prestamos': 'préstamos',
    'Prestamos': 'Préstamos',
} as any

const changeWords = (texts: string[]) => {
    const newTexts = [];
    for (let i = 0; i < texts.length; i++) {
        const text = texts[i];
        const words = text?.split(' ');
        const changedWords = words?.map(word => {
            if (WORDS_TO_CHANGE[word]) {
                return WORDS_TO_CHANGE[word];
            }
            return word;
        });
        newTexts.push(changedWords?.join(' '));
    
    }
    return newTexts;
}



const PrivateRoute = (
    { children, hiddenHeader, hiddenTitle }: 
    { children: JSX.Element, hiddenHeader?: boolean, hiddenTitle?: boolean}) => {
    const dispatch = useDispatch<AppDispatch>();
    const theme = useTheme();
    const navigate = useNavigate();
    const authState = useSelector((state: RootState) => state.auth);
    const [routeLevels, setRouteLevels] = useState<string[]>([])

    useEffect(() => {
        if (authState.isLogged === null) {
          dispatch(loadAuthData());
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authState.companyselected])
    useEffect(() => {
        if (authState.isLogged === false || (authState.isLogged === true && !authState.companyselected)) {
            navigate('/ingresar')
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authState.isLogged])

    // useEffect(() => {
    //     setRouteLevels(location.pathname.split("/").filter(label => label !== ""))
    // // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [location.pathname])

    return (
        <AppMenu setMenuRoute={setRouteLevels} key={String(routeLevels)} hiddenHeader={hiddenHeader}>
            <Grid 
                container 
                direction="row" 
                // padding="1.5rem 2rem" 
                style={{
                    backgroundColor: "#F5F5F5", 
                    // width: "fit-content",
                    height: "100%",
                    width: "-webkit-fill-available", 
                    minWidth: "-webkit-fill-available", 
                }}
            >
                {hiddenHeader !== true && <Grid 
                    item 
                    width="100%" 
                    sx={{ display: { xs: 'none', md: 'block' } }}
                >
                    <BreadCrumbsBar
                        breadcrumbsItems={changeWords(routeLevels)}
                    />
                </Grid>}
                {hiddenHeader !== true && hiddenTitle !== true &&<Grid 
                    item 
                    width="100%" 
                    marginTop=".5rem"
                    sx={{ display: { xs: 'none', md: 'block' } }}
                >
                    <Typography variant="h3" color={theme.s10palette.S10Greygrey600}>
                        {changeWords(routeLevels.slice(-1))}
                    </Typography>
                </Grid>}
                {children}
            </Grid>
        </AppMenu>
    );

}

export default PrivateRoute;